import Image3 from '../apartment2/beach.webp'
import Image4 from '../apartment2/beach2.webp'
import Image5 from '../apartment2/bedroom.webp'
import Image6 from '../apartment2/bedroom2.webp'
import Image7 from '../apartment2/bedroom3.webp'
import Image8 from '../apartment2/bedroom4.webp'
import Image9 from '../apartment2/bedroom5.webp'
import Image10 from '../apartment2/garden.webp'
import Image11 from '../apartment2/garden2.webp'
import Image12 from '../apartment2/garden3.webp'
import Image13 from '../apartment2/kitchen.webp'
import Image14 from '../apartment2/kitchen2.webp'
import Image15 from '../apartment2/livingroom.webp'
import Image16 from '../apartment2/livingroom2.webp'
import Image17 from '../apartment2/livingroom3.webp'
import Image18 from '../apartment2/livingroom4.webp'
import Image19 from '../apartment2/outside.webp'
import Image20 from '../apartment2/outside2.webp'
import Image21 from '../apartment2/stairway.webp'
import Image22 from '../apartment2/view.webp'
import Image23 from '../apartment2/view2.webp'

const ApartmentTwoImages = [
    {
        id: 15,
        image: Image15,
    }, {
        id: 16,
        image: Image16,
    }, {
        id: 17,
        image: Image17,
    }, {
        id: 18,
        image: Image18,
    }, {
    id: 3,
    image: Image3,
  }, {
    id: 4,
    image: Image4,
  }, {
    id: 5,
    image: Image5,
  }, {
    id: 6,
    image: Image6,
  }, {
    id: 7,
    image: Image7,
  }, {
    id: 8,
    image: Image8,
  }, {
    id: 9,
    image: Image9,
  }, {
    id: 10,
    image: Image10,
  }, {
    id: 11,
    image: Image11,
  }, {
    id: 12,
    image: Image12,
  }, {
    id: 13,
    image: Image13,
  }, {
    id: 14,
    image: Image14,
  },{
    id: 19,
    image: Image19,
  }, {
    id: 20,
    image: Image20,
  }, {
    id: 21,
    image: Image21,
  }, {
    id: 22,
    image: Image22,
  }, {
    id: 23,
    image: Image23,
  }
]

export default ApartmentTwoImages
